export default __webpack_public_path__ + "static/media/scroll.b3bad4d8.svg";